module.exports = __webpack_public_path__ + "img/chinesecompany143.f468efaf.png";